import { render, staticRenderFns } from "./SysAppUpgradeModal.vue?vue&type=template&id=25423bd0&"
import script from "./SysAppUpgradeModal.vue?vue&type=script&lang=js&"
export * from "./SysAppUpgradeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports